import ModalRoot from './ModalRoot'

export default ModalRoot
